import React from 'react';
import { Text, TextProps } from '../components';

export const splitMultilineText = (text: string, textVariant?: TextProps['variant'], className?: string) =>
  text.split(/[\r\n]+/gm).map((paragraph, i) => (
    <Text key={i} variant={textVariant} className={className}>
      {paragraph}
    </Text>
  ));
